/**
 * src/lib/core/sections/swagger.ts
 *
 * Scaffolds `src/app/config/swagger.ts` for OpenAPI 3.0 documentation.
 */

import fs from 'fs';
import path from 'path';

/**
 * Writes `src/app/config/swagger.ts` into the scaffolded project root.
 *
 * @param projectPath - Absolute path to the project root.
 */
export function scaffoldSwagger(projectPath: string): void {
  const configDir = path.join(projectPath, 'src/app/config');
  if (!fs.existsSync(configDir)) {
    fs.mkdirSync(configDir, { recursive: true });
  }

  const content = `import swaggerJsdoc from 'swagger-jsdoc';
import config from './index';

const options: swaggerJsdoc.Options = {
  definition: {
    openapi: '3.0.0',
    info: {
      title: 'CEM Modular Express API',
      version: '1.0.0',
      description: 'Interactive OpenAPI 3.0 documentation generated by Create Express Modular CLI.',
    },
    servers: [
      {
        url: \`http://localhost:\${config.port}/api/v1\`,
        description: 'Development Server',
      },
    ],
    components: {
      securitySchemes: {
        bearerAuth: {
          type: 'http',
          scheme: 'bearer',
          bearerFormat: 'JWT',
        },
      },
    },
  },
  apis: ['./src/app/modules/**/*.route.ts', './src/app/modules/**/*.controller.ts'],
};

export const swaggerSpec = swaggerJsdoc(options);
`;

  fs.writeFileSync(path.join(configDir, 'swagger.ts'), content);
}
